<template>
  <router-view />
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.bg-grad-grey {
  background: linear-gradient(to right, #e6e6e6 0%, #fdfdfd 50%, #e6e6e6 100%);
}
.bg-grad-blue {
  background: linear-gradient(to right, #dceefb 0%, #f0f8ff 50%, #dceefb 100%);
}
.bg-grad-green {
  background: linear-gradient(to right, #dff5e1 0%, #f0fff0 50%, #dff5e1 100%);
}
.bg-grad-yellow {
  background: linear-gradient(to right, #fff9db 0%, #fffff0 50%, #fff9db 100%);
}
.bg-grad-purple {
  background: linear-gradient(to right, #f0e6f9 0%, #faf5ff 50%, #f0e6f9 100%);
}
.bg-grad-orange {
  background: linear-gradient(to right, #ffeccd 0%, #fff8e6 50%, #ffeccd 100%);
}
</style>
